module.exports = __webpack_public_path__ + "img/icon-hamburger-close.2a9ea479.svg";